import { styled } from "@mui/material/styles"
import { CustomButtonV2 } from "../styles";

export const ContainerForm = styled('div')(() => {
  return {
    display: 'flex',
    marginTop: '14px',
    flexDirection: 'column',
    width: '100%',
  }
})

export const FormButton = styled(CustomButtonV2)(() => {
  return {
    color: '#343434',
    borderColor: '#d5d5d5ff',
  }
})

export const SaveButton = styled(CustomButtonV2)(() => {
  return {
    color: '#fffff',
    background: '#22c55e',
    borderColor: '#22c55e',
  }
})
